"use client";
import React from "react";
import Image from "next/image";
import { FaFacebookF, FaTelegram } from "react-icons/fa";
import { FaDiscord } from "react-icons/fa6";
import { MdEmail } from "react-icons/md";

function Footer() {
  return (
    <footer className="bg-black text-gray-300 p-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h3 className="text-xl font-bold text-orange-400 mb-4">
            Mephimchill
          </h3>
          <p className="text-sm">
            Nơi hội tụ những bộ anime đỉnh cao, mang đến trải nghiệm tuyệt vời
            cho fan anime!
          </p>
        </div>
        <div>
          <h3 className="text-xl font-bold text-orange-400 mb-4">Liên kết</h3>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="#" className="hover:text-orange-400 transition-colors">
                Về chúng tôi
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-orange-400 transition-colors">
                Liên hệ
              </a>
            </li>
            <li>
              <a href="#" className="hover:text-orange-400 transition-colors">
                Chính sách
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="text-xl font-bold text-orange-400 mb-4">
            Theo dõi chúng tôi
          </h3>
          <div className="flex gap-4">
            <a
              href="#"
              className="p-2 bg-orange-500 rounded-full hover:bg-orange-600 transition-all shadow-[0_0_10px_rgba(236,72,153,0.5)]"
            >
              <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24">
                <path d="M24 4.56v14.88A4.56 4.56 0 0 1 19.44 24H4.56A4.56 4.56 0 0 1 0 19.44V4.56A4.56 4.56 0 0 1 4.56 0h14.88A4.56 4.56 0 0 1 24 4.56zM9.6 18.4v-6.72H7.2V9.6h2.4V7.44c0-2.4 1.44-3.72 3.6-3.72 1.04 0 1.92.08 2.16.12v2.52h-1.44c-1.12 0-1.36.56-1.36 1.36V9.6h2.76l-.36 2.08h-2.4v6.72H9.6z" />
              </svg>
            </a>
            <a
              href="#"
              className="p-2 bg-orange-500 rounded-full hover:bg-orange-600 transition-all shadow-[0_0_10px_rgba(236,72,153,0.5)]"
            >
              <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24">
                <path d="M12 2.04c-5.52 0-10 4.48-10 10 0 4.48 2.88 8.28 6.88 9.64.48.08.64-.24.64-.48v-1.68c-2.8.64-3.36-1.36-3.36-1.36-.48-1.2-1.12-1.52-1.12-1.52-.96-.64.08-.64.08-.64 1.04.08 1.6 1.04 1.6 1.04.96 1.68 2.48 1.2 3.12.92.08-.72.4-1.2.72-1.44-2.48-.28-5.04-1.24-5.04-5.52 0-1.2.4-2.24 1.12-3.04-.12-.28-.48-1.36.12-2.8 0 0 .88-.28 2.88 1.08a9.6 9.6 0 0 1 5.28 0c2-1.36 2.88-1.08 2.88-1.08.6 1.44.24 2.52.12 2.8.72.8 1.12 1.84 1.12 3.04 0 4.28-2.56 5.24-5.04 5.52.4.32.72.96.72 1.92v2.88c0 .24.16.56.64.48A10.02 10.02 0 0 0 22 12.04c0-5.52-4.48-10-10-10z" />
              </svg>
            </a>
            <a
              href="#"
              className="p-2 bg-orange-500 rounded-full hover:bg-orange-600 transition-all shadow-[0_0_10px_rgba(236,72,153,0.5)]"
            >
              <svg className="h-5 w-5" fill="white" viewBox="0 0 24 24">
                <path d="M22.46 6c-.77.34-1.6.58-2.46.68.88-.52 1.56-1.36 1.88-2.36-.82.48-1.74.84-2.72 1.04C18.36 4.5 17.26 4 16 4c-2.2 0-4 1.8-4 4 0 .32.04.64.08.96C8.56 8.8 5.56 7.16 3.56 4.8 3.2 5.4 3 6.08 3 6.8c0 1.4.72 2.64 1.8 3.36-.66-.02-1.28-.2-1.84-.5v.04c0 1.96 1.4 3.6 3.24 3.96-.34.1-.7.14-1.08.14-.26 0-.52-.02-.78-.06.52 1.64 2.04 2.84 3.84 2.88-1.4 1.1-3.16 1.76-5.08 1.76-.34 0-.68-.02-1-.06 1.84 1.18 4.04 1.88 6.4 1.88 7.68 0 11.88-6.36 11.88-11.88 0-.18 0-.36-.02-.54.82-.58 1.54-1.32 2.1-2.16z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="mt-8 text-center text-sm border-gray-800 pt-4 border-t flex items-center justify-center gap-x-2">
        Liên hệ quảng cáo: accvip1901@gmail.com <MdEmail color="white" />
      </div>
      <div className="text-center text-sm ">
        © 2025 Mephimchill. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
